import moment from 'moment';
import {
  flow,
  get,
  includes,
  isEmpty,
  isNumber,
  join,
  map,
  split,
  startCase
} from 'lodash/fp';
import htmlParser from 'react-html-parser';
import { StringOrNumberType } from '../../../interfaces';
import { ColumnSettingsType } from '../../../interfaces/guest';

const EmptyValue = '""';
const BoleanFields = ['homeless', 'isMember', 'blackball'];

const GuestFieldValue = ({ value, colSettings }) => {
  const { name, fieldType, options = [] } = colSettings;

  if (name === 'name') {
    return startCase(value) || EmptyValue;
  }
  if (name === 'profilePicture') {
    return 'with a new photo';
  }
  if (name === 'reason') {
    if (!value) return EmptyValue;
    return flow(
      split(','),
      map(val => htmlParser(get(val, options))),
      join(', ')
    )(value);
  }
  if (!isEmpty(options)) {
    return get(`options.${value}`, colSettings) || EmptyValue;
  }
  if (includes(name, BoleanFields)) {
    return value === '1' || value === 1 ? 'Yes' : 'No';
  }

  switch (fieldType) {
    case 'date':
      // eslint-disable-next-line no-case-declarations
      const date = isNumber(value) ? moment(value * 1000) : value;
      return moment(date).format('ll');
    case 'datetime':
      // eslint-disable-next-line no-case-declarations
      const datetime = isNumber(value) ? moment(value * 1000) : value;
      return moment(datetime).format('lll');
    default:
      return value || EmptyValue;
  }
};

GuestFieldValue.propTypes = {
  value: StringOrNumberType.isRequired,
  colSettings: ColumnSettingsType.isRequired
};

export default GuestFieldValue;
